// removed by extract-text-webpack-plugin
module.exports = {"button":"button__BahAJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/giveFeedbackEmbedModal/style.scss
// module id = 261
// module chunks = 0